import { render, staticRenderFns } from "./Sapp.vue?vue&type=template&id=7e48f334&scoped=true"
import script from "./Sapp.vue?vue&type=script&lang=js"
export * from "./Sapp.vue?vue&type=script&lang=js"
import style0 from "./Sapp.vue?vue&type=style&index=0&id=7e48f334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e48f334",
  null
  
)

export default component.exports